import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

// Public business pages → "Sazināties ar uzņēmumu". Logged-in visitors open a
// KoLV chat with the owner; anonymous visitors are nudged to the on-page
// contact form (or login) per product decision.
export const ContactBusinessButton = ({ ownerId, ownerName, fullWidth = false, className = '' }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handle = () => {
    if (!ownerId) return;
    if (user) {
      navigate(`/messages?to=${ownerId}&name=${encodeURIComponent(ownerName || 'Uzņēmums')}`);
      return;
    }
    const el = document.querySelector('[data-testid="contact-section"]');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      toast.info('Pieslēdzies, lai rakstītu čatā, vai aizpildi kontaktformu zemāk');
    } else {
      toast.info('Pieslēdzies, lai rakstītu uzņēmumam čatā');
      navigate('/welcome');
    }
  };

  return (
    <button
      onClick={handle}
      data-testid="contact-business-btn"
      className={`inline-flex items-center justify-center gap-2 h-11 px-6 rounded-full bg-[var(--accent)] text-[var(--accent-contrast)] text-sm font-bold hover:bg-[var(--accent-hover)] transition-transform hover:scale-105 ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      <MessageSquare className="w-4 h-4" /> Sazināties ar uzņēmumu
    </button>
  );
};

export default ContactBusinessButton;
